import styled from '../lib/styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${p => p.theme.font.family};
  background-color: ${p => p.theme.colors.background};
  height: 100%;
`

export const Main = styled.div`
  flex-grow: 1;
  padding-top: 50px;
`

export const Playlists = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* align-content: center; */
  align-content: flex-start;
  padding-top: 10px;
  background-color: ${p => p.theme.colors.secondary};
  min-height: 700px;
`
